import { Navigate, Outlet, useLocation } from "react-router";

// De laadstaat hieronder hoort bij het inlogscherm en gebruikt dezelfde
// stylesheet. Die wordt hier expliciet geïmporteerd: `RequireAuth` rendert
// vóór het inlogscherm, dus wachten tot dat scherm zijn eigen CSS meebrengt
// zou een ongestileerde tussenstap opleveren.
import "@/pages/SignIn.css";

import { rememberReturnTo, useAuth } from "./authState";

/**
 * De poort voor de hele applicatie: alles achter deze route vereist een account.
 *
 * Bewust één bewaking om de schil heen en niet per scherm — hetzelfde patroon
 * als `enforce_write_access` aan de backendkant, waar de autorisatie op de
 * router hangt zodat een nieuw endpoint er nooit per ongeluk buiten valt. Een
 * nieuw scherm in `routes.tsx` staat hier automatisch achter.
 *
 * Dit is een *schermbewaking*, geen beveiliging: de gegevens zitten achter de
 * API, en die beoordeelt elk verzoek zelf op het access-token. Wie de bundel
 * uitpakt vindt hier geen data, alleen lege schermen.
 */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "initialising") {
    return (
      <div className="atl-auth-boot" role="status">
        <p>Bezig met aanmelden…</p>
      </div>
    );
  }

  if (status !== "signed-in") {
    // Waar iemand heen wilde gaat mee via sessionStorage en niet via de
    // routerstate: bij Entra verlaat de browser de applicatie volledig, en dan
    // is elke state in het geheugen weg.
    rememberReturnTo(`${location.pathname}${location.search}`);
    return <Navigate to="/inloggen" replace />;
  }

  return <Outlet />;
}
